import { getVehicleEquipment } from '../../server/api/mappers/vehicles.helpers';

/**
 * Honda
 *
 * ```
 *     State:   Unsold - Below reserve bid
 *    Images:   1
 *      Bids:   52
 * User bids:   0
 *    Mapper:   No
 * ```
 */
export default (extension = {}) => {
	const vehicle = {
		additionalDetails: null,
		additionalSpec: '5 year service package, 2 more services free.\n',
		availableFrom: '2016-02-04T00:00:00.000Z',
		availableUntil: null,
		bids: {
			activeBidCount: 52,
			usersBids: [],
		},
		dentsDesc: null,
		displayPrice: 9391,
		electricsProblemsDesc: null,
		equipment: 'sat_nav,panoramic_roof,heated_seats,parking_cam,sound_system',
		exteriorGrade: 'gold',
		hasBeenSmokedIn: true,
		hasDents: false,
		hasElectricsProblems: null,
		hasLockingWheelNut: true,
		hasMissingParts: false,
		hasOtherContactActiveBid: false,
		hasPaintProblems: false,
		hasPrivatePlate: false,
		hasScratches: false,
		hasScuffedAlloy: true,
		hasServiceRecords: true,
		hasToolsInBoot: true,
		hasWarningLights: false,
		hasWindscreenProblems: true,
		highestBid: 8712,
		id: 420050,
		independentServiceStampsCount: 0,
		interiorType: 'Cloth',
		isTrade: true,
		isVatQualifying: false,
		isVehicleOnFinance: false,
		keeperStartDate: '2016-09-06T00:00:00.000Z',
		keysCount: 2,
		lastMOTDate: '2019-09-05T00:00:00.000Z',
		mileage: 13000,
		minimumBid: {
			type: 'offer',
			value: 4000,
		},
		missingPartsDesc: null,
		numericGrade: '4',
		officialServiceStampsCount: 3,
		paintProblemsDesc: null,
		prettyVrm: 'GK66 LDE',
		previousKeepersCount: null,
		priceAverageCondition: 28100,
		priceGoodCondition: 27300,
		priceRetail: 31300,
		priceSource: 'UKVD',
		priceUpdatedAt: '2019-09-05T00:00:00.000Z',
		scratchesDesc: null,
		scuffedAlloyDesc: 'Scuffs on  all 4 alloys.\n',
		seller: {
			distance: 147,
			town: 'Stoke-on-Trent',
		},
		sellerWillAcceptPrice: 9391,
		serviceHistory: 'full',
		serviceHistoryRecords: {
			count: 3,
			items: [
				{
					createdAt: '2023-06-19T09:15:41.940Z',
					date: '2021-05-24T00:00:00.000Z',
					id: 18,
					mileage: 1234,
					serviceCentre: null,
					serviceCentreId: null,
					type: 'idrive',
					updatedAt: '2023-06-19T09:15:41.940Z',
					userUpdated: true,
					vehicleImageId: 317158,
				},
				{
					createdAt: '2023-06-19T09:15:41.940Z',
					date: '2020-06-02T00:00:00.000Z',
					id: 19,
					mileage: null,
					serviceCentre: null,
					serviceCentreId: '14040',
					type: 'idrive',
					updatedAt: '2023-06-19T09:15:41.940Z',
					userUpdated: false,
					vehicleImageId: 317158,
				},
				{
					createdAt: '2023-06-19T09:15:41.940Z',
					date: '2018-05-30T00:00:00.000Z',
					id: 21,
					mileage: 8384,
					serviceCentre: null,
					serviceCentreId: '09062',
					type: 'idrive',
					updatedAt: '2023-06-19T09:15:41.940Z',
					userUpdated: false,
					vehicleImageId: 317158,
				},
			],
		},
		serviceRecord: 'full',
		soldDate: null,
		spec: {
			body: 'Hatchback',
			bodyCategory: 'Hatchback',
			colour: 'Silver',
			engineSize: 1318,
			firstRegistered: '2016-09-06T00:00:00.000Z',
			fuel: 'Petrol',
			make: 'Honda',
			model: 'Jazz SE I-VTEC CVT',
			transmission: 'Automatic',
			vin: 'JHMGK3850GX245614',
		},
		state: {
			category: 'unsold',
			id: 90,
			name: 'Unsold - Below reserve bid',
			slug: 'unsold_below_reserve_bid',
		},
		tyreProblemsDesc: null,
		vehicleImages: [
			{
				createdAt: '2020-06-22T11:56:01.469Z',
				enquiryId: 420050,
				id: 664065,
				kind: 'exterior_front_driver',
				meta: {
					canvas: {
						height: 873,
						left: 117,
						naturalHeight: 2448,
						naturalWidth: 3264,
						top: 87,
						width: 1163,
					},
					cropBox: {
						height: 838,
						left: 140,
						top: 105,
						width: 1117,
					},
					height: 2350,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
					width: 3134,
					x: 65,
					y: 49,
				},
				source: 'motorway-seller-webapp:310941a974547001791a7154341ef55dc9fa3bff',
				url: 'https://motorway.imgix.net/0050/420050/exterior_front_driver-1592826941485.jpg',
			},
		],
		vrm: 'GK66LDE',
		warningLightsDesc: null,
		windscreenProblemsDesc: 'Some problem',
		year: 2016,
	};

	return {
		...vehicle,
		equipmentV2: getVehicleEquipment(vehicle),
		...extension,
	};
};
